import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Code from '../views/Code.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import New from '../views/New.vue'
import Leads from  '../views/Leads.vue'
import Lead from  '../views/Lead.vue'
import Estimator from '../views/Estimator.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/new',
    name: 'New',
    component: New,
    meta: {
      public: false,  // Allow access to only loggedin user.
    }
  },
  {
    path: '/lead/:id',
    name: 'Lead',
    component: Lead,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'estimator/leads/get',
      title: 'Lead',
      key: 'lead'
    }
  },
  {
    path: '/leads',
    name: 'Leads',
    component: Leads,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      api: 'estimator/leads/all?page=',
      title: 'All Leads',
      key: 'all'
    }
  },
  {
    path: '/unassigned',
    name: 'Unassigned Leads',
    component: Leads,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'estimator/leads/unassigned?page=',
      title: 'Unassigned Leads',
      key: 'new'
    }
  },
  {
    path: '/myleads',
    name: 'My Leads',
    component: Leads,
    meta: {
      public: false,  // Allow access to only loggedin user.
      api: 'estimator/leads/my?page=',
      title: 'My Leads',
      key: 'my'
    }
  },
  {
    path: '/schedule/:id',
    name: 'Schedule',
    component: Estimator,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.,
      title: 'Select a Schedule'
    }
  },
  {
    path: '/code',
    name: 'Code',
    component: Code,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }
  next();
}) 

export default router
